import { Component, EventEmitter, Output } from '@angular/core';
import { SimpleModalComponent } from 'ngx-simple-modal';

export interface ConfirmModal {
  title?: string;
  message?: string;
  description?: string;
  cancelText?: string;
  confirmText?: string;
  cancelClass?: string;
  confirmClass?: string;
}

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.sass'],
})
export class ConfirmModalComponent extends SimpleModalComponent<ConfirmModal, boolean> implements ConfirmModal {
  title: string = 'Megerősítés';
  message: string = 'Biztosan végre szeretné hajtani a műveletet?';
  description?: string = undefined;
  cancelText: string = 'Mégse';
  confirmText: string = 'Megerősítés';
  cancelClass: string = 'btn-dark';
  confirmClass: string = 'btn-primary';

  @Output() onConfirm: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {
    super();
  }

  confirm() {
    this.result = true;
    this.close();
    this.onConfirm.emit(this.result);
  }
}
